import React from 'react';
import { ExperiencesBubbleScreen } from '../components/ExperiencesBubbleScreen';
interface CantinaScreenProps {
  onMenuClick: () => void;
}
export function CantinaScreen({
  onMenuClick
}: CantinaScreenProps) {
  return <ExperiencesBubbleScreen onMenuClick={onMenuClick} data-id="element-234" />;
}